import React, { useContext, useEffect, useRef, useState } from "react";
import { backIncstance, getLoginInfo } from "../../utils/commonFunctions";
import { MyContext } from "../../context/MyContext";
import SelectBox from "../../components/SelectBox";
import Chat from "../chat/components/Chat";

import ndjsonStream from "can-ndjson-stream";
import { useLocation } from "react-router-dom";

//icons
import Send from "../../assets/icons/icon_send.png";
import Minimizing from "../../assets/icons/icon_minimize.png";
import Maximizing from "../../assets/icons/icon_maximize.png";
import Close from "../../assets/icons/icon_close.png";
import styled from "styled-components";
import { clarioApi } from "../../api/clarioApi";

const URLS = {
  DONGA: process.env.REACT_APP_REFERER_URL,
  CLARIO: process.env.REACT_APP_CLARIO_SERVER,
  GET_PERSONA_LIST: process.env.REACT_APP_SETTINGS_GET_PERSONA_LIST,
  EDIT_PERSONA_LIST: process.env.REACT_APP_SETTINGS_EDIT_PERSONA_LIST,
  // EDIT_PERSONA_LIST: 'https://ds.back.clabi.co.kr/api/v1/mypage/persona',
  // CHECK_PERSONA: process.env.REACT_APP_SETTINGS_CHECK_PERSONA,
  CHECK_PERSONA: process.env.REACT_APP_SETTINGS_CHECK_PERSONA,
};

const EMPTY = /^\s*$/;
const WAITING_TEXT = `답변을 생성중입니다. 잠시만 기다려주세요.`;

const Persona = (props) => {
  const {
    user,
    setUser,
    setAlertSetting,
    paramId,
    fetching,
    setFetching,
    setIsLogin,
    searchContent,
    pieceDataSumRef,
    controllerRef,
    setSearchContent,
  } = useContext(MyContext);

  const [history, setHistory] = useState([]);
  const customRef = useRef(null);
  const inputRef = useRef(null);

  const location = useLocation();

  const [options, setOptions] = useState([]);
  const [persona, setPersona] = useState(null);

  const [queryString, setQueryString] = useState({
    messages: [
      {
        role: "assistant",
        content: "",
        query_type: null,
        response_id: "",
        response_time: 0,
      },
    ],
    persona: persona,
    query: null,
  });

  // 엔터키 입력시 질문 전송후 textarea clear
  useEffect(() => {
    if (true) {
      const inputValue = inputRef.current.value;
      const lastIdx = queryString.messages.length - 1;

      const isOver =
        queryString.messages[lastIdx].content === null ? true : false;

      if (inputValue !== "") {
        fetchData(URLS.CLARIO);
        inputRef.current.value = "";
      }
    }
  }, [queryString.messages.length]);

  const touchAPI = async (method, url, data) => {
    try {
      const response = await backIncstance(method, url, data);
      const resData = await response.json();
      let text;

      if (response.status === 200 || response.status === 201) {
        if (url === URLS.GET_PERSONA_LIST) {
          const myData = resData.persona_list;
          const newArr = myData.map((item) => ({
            value: item.id,
            label: item.tone,
          }));
          setOptions(newArr);
          // setPersona(newArr[0].label)
        } else if (url === URLS.EDIT_PERSONA_LIST) {
          text = "완료되었습니다.";
          if (method === "POST") {
            customRef.current.value = "";
            text = "새로운 페르소나가 정의되었습니다.";
          } else if (method === "PATCH") {
            text = "페르소나 기본값이 변경되었습니다.";
            setUser((prev) => ({
              ...prev,
              tone: persona,
            }));
          } else if (method === "DELETE") {
            text = "페르소나가 삭제되었습니다.";
          }

          touchAPI("GET", URLS.GET_PERSONA_LIST);
        }
      } else if (response.status === 400) {
        text = resData.detail ? resData.detail : "다시 시도해주세요.";
      }
      if (text) {
        setAlertSetting((prev) => ({
          ...prev,
          alertTxt: text,
        }));
      }
    } catch (err) {
      setAlertSetting((prev) => ({
        ...prev,
        alertTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`,
        btnTxt: "닫기",
      }));
    } finally {
      setChecking(false);
    }
  };

  const delayLoop = async (jsonString) => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        try {
          resolve(jsonString);
        } catch (error) {
          reject(error);
        }
      }, 0); // 40ms 지연
    });
  };

  const [checking, setChecking] = useState(false);
  const handleTextControl = (item) => {
    if (item?.type === "all") {
      setHistory((prev) => {
        const copy = [...prev];
        // 배열의 특정 인덱스에 있는 객체를 복사하여 새로운 객체를 만들고 속성 변경
        const updatedItem = {
          ...copy[0], // 원본 객체 복사
          response: item.response,
          action: "chat",
          response_id: item?.response_id, // res.response_id가 success 케이스에서 유효한지 확인 필요
          last_result: true,
        };
        copy[0] = updatedItem; // 새로운 객체로 대체

        return copy;
      });
    }
    if (item.text === "\n") {
      item.text = "<br>";
    }
    pieceDataSumRef.current += item.text;
  };

  const fetchData = async (url, data) => {
    var config = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        "Access-Control-Allow-Origin": "*",
      },
      body:
        url === URLS.CHECK_PERSONA
          ? JSON.stringify(data)
          : JSON.stringify(queryString),
      payload: JSON.stringify({
        engine: "curie",
        temperature: 0.75,
        top_p: 0.95,
        max_tokens: 3,
        stream: true,
        stop: ["\n\n"],
      }),
    };
    if (url === URLS.CHECK_PERSONA) {
      try {
        setChecking(true);
        const res = await fetch(url, config);
        const resData = await res.json();
        if (resData.detail) {
          const text = resData.detail.body;
          setAlertSetting((prev) => ({
            ...prev,
            alertTxt: text
              ? text
              : `나만의 페르소나는 ~한 말투로 지정해주세요.`,
          }));
        } else {
          const reqData = {
            // user_pk: user.id,
            tone: data.input_text,
          };
          touchAPI("POST", URLS.EDIT_PERSONA_LIST, reqData);
        }
      } catch (err) {
        setAlertSetting((prev) => ({
          ...prev,
          alertTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`,
          btnTxt: "닫기",
        }));
      } finally {
        setChecking(false);
      }
    } else {
      setFetching(true);
      try {
        const abortController = new AbortController();
        controllerRef.current = abortController;

        const reqData = {
          query: queryString.query,
          messages: [],
          persona: persona,
          is_recommended: false,
        };
        const res = await clarioApi(
          process.env.REACT_APP_CLARIO_SERVER,
          reqData,
          handleTextControl,
          abortController
        );
        if (res === "error") {
          setHistory((prev) => {
            const copy = [...prev];
            // 배열의 특정 인덱스에 있는 객체를 복사하여 새로운 객체를 만들고 속성 변경
            const updatedItem = {
              ...copy[0], // 원본 객체 복사
              response: "잠시후에 다시 시도해주세요.",
              action: "chat",
              response_id: res.response_id, // res.response_id가 error 케이스에서 유효한지 확인 필요
              last_result: true,
            };
            copy[0] = updatedItem; // 새로운 객체로 대체
            return copy;
          });
        }
      } catch (err) {
        setAlertSetting((prev) => ({
          ...prev,
          alertTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`,
          btnTxt: "닫기",
        }));
      } finally {
        controllerRef.current = null;
        setSearchContent("");
        pieceDataSumRef.current = "";
        setFetching(false);
      }
    }
  };

  const isLoginUser = async () => {
    try {
      const result = await fetch(
        `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_LOGIN_CHECK_URL}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      );
      if (result.status === 200 || result.status === 201) {
        const resData = await result.json();
        setUser((prev) => ({
          ...prev,
          id: resData.profile_id,
          name: resData.name,
          picture_extension: resData.picture_extension,
          picture_data: resData.picture_data,
          paid: resData.paid,
          tone: resData.tone,
          start_dt: resData.start_dt,
          end_dt: resData.end_dt,
          tutor_cnt: resData.tutor_cnt,
          socra_cnt: resData.socra_cnt,
        }));
        localStorage.setItem("userInfo", JSON.stringify(resData));
        setIsLogin(false);
      }
    } catch (e) {
      setAlertSetting((prev) => ({
        ...prev,
        alertTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`,
        btnTxt: "닫기",
      }));
    }
  };

  const onConfirmDelete = (e) => {
    const title = e.label;
    setAlertSetting((prev) => ({
      ...prev,
      alertTxt: `${title}을/를 삭제하시겠습니까?`,
      double: true,
      btnTxt: "삭제하기",
      onConfirm: () => {
        if (typeof prev.onConfirm === "function") {
          prev.onConfirm();
        }
        handleDelete(e);
      },
    }));
  };

  const handleSubmitQuestion = (e) => {
    e.preventDefault();

    if (!persona) {
      setAlertSetting((prev) => ({
        ...prev,
        alertTxt: "페르소나를 선택해주세요.",
        btnTxt: "닫기",
      }));
      return;
    }
    const inputValue = inputRef.current.value;

    if (fetching || !inputValue) {
      return false;
    }

    if (history.length === 0) {
      setHistory((prev) => {
        const copy = [...prev];
        copy.push({
          input_text: inputValue,
          response: WAITING_TEXT,
          action: "chat",
          response_id: null,
          last_result: false,
          naversearch: false,
          comment: "",
          isShowDetail: false,
          id: null,
          isComment: false,
          user_eva: {
            eva: null,
            simple_eva: null,
          },
        });
        return copy;
      });
    } else {
      setHistory((prev) => {
        const copy = [...prev];
        copy[0].input_text = inputValue;
        copy[0].answer = WAITING_TEXT;
        copy[0].action = "chat";
        copy[0].response_id = null;
        return copy;
      });
    }
  };

  const handleSubmitForm = (e, target) => {
    e.preventDefault();

    if (fetching || checking) return;
    if (target === "role") {
      const reqData = {
        // user_pk: user.id,
        tone: persona,
      };
      touchAPI("PATCH", URLS.EDIT_PERSONA_LIST, reqData);
    } else {
      const value = customRef.current.value;

      if (value) {
        const reqData = {
          input_text: value,
        };
        fetchData(URLS.CHECK_PERSONA, reqData);
      } else {
        setAlertSetting((prev) => ({
          ...prev,
          alertTxt: `나만의 페르소나를 정의할 수 있는 내용을 입력해주세요.`,
        }));
      }
    }
  };
  // 엔터키 입력시 질문 전송
  const checkKeyType = (e) => {
    const keyName = e.key;
    const isEmpty = EMPTY.test(inputRef.current.value);
    if (e.nativeEvent.isComposing || isEmpty) return;
    if (keyName === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSubmitQuestion(e);
    }
  };
  const hasFetchedPersona = useRef(false); // 초기에만 실행되도록 설정, 아니면 클라리오 통신 에러
  useEffect(() => {
    touchAPI("GET", URLS.GET_PERSONA_LIST);
    if (user && user.tone && !hasFetchedPersona.current) {
      setPersona(user.tone);
      hasFetchedPersona.current = true; // 실행했음을 기록
    }
  }, [user]);

  useEffect(() => {
    if (history.length === 0) {
      setQueryString((prev) => ({
        query: null,
        messages: [
          {
            role: "assistant",
            content: "",
            query_type: null,
            response_id: "",
            response_time: 0,
          },
        ],
        persona: "",
      }));
    }

    // 시간 초과 후 입력값이 없을 때, 혹은 있을 때 해당 값 전송....
    else if (history.length !== 0) {
      const inputValue = inputRef.current.value;
      const messageIdx = queryString.messages.length - 1;

      if (inputValue !== "") {
        setQueryString((prev) => ({
          ...prev,
          query: inputValue,
          messages: [
            ...prev.messages,
            {
              role: "user",
              content: inputValue ? inputValue : null,
              response_id: queryString.messages[messageIdx]?.response_id,
              response_time: 0,
            },
          ],
          persona: persona,
        }));
      }
    }
    // else if (history.length !== 0 && isNewTime) {
    //   const lastIdx = history.length - 1;
    //   if ((history[lastIdx].question_count === 9 && history[lastIdx].followup_count === 2) || history[lastIdx].question_count === 10) {
    //     setIsFinish(true)
    //   } else if (history[lastIdx].question_count < 10) {
    //     setIsFinish(false)
    //   }
    // }
  }, [history, paramId]);

  useEffect(() => {
    setHistory([]);
  }, [location.pathname]);

  useEffect(() => {
    const loginInfo = getLoginInfo();
    if (!loginInfo.id) {
      setIsLogin(true);
      return;
    }
    isLoginUser();
  }, []);

  const handleDelete = async (e) => {
    touchAPI("DELETE", URLS.EDIT_PERSONA_LIST, `/${Number(e.value)}`);
  };

  const handleSelect = (e) => {
    setPersona(e.label);
    setUser((prev) => ({
      ...prev,
      tone: e.value,
    }));
  };

  return (
    <Style>
      <div className="ctn-wrp  peronsa-wrp">
        <div className="setting-wrapper top">
          <form
            className="form-wrapper"
            onSubmit={(e) => handleSubmitForm(e, "role")}
          >
            <div className="flx-box sep-elm">
              <p className="title">역할/어투 설정</p>
            </div>
            <div className="contents">
              <div className="select flx-box sep-elm">
                <SelectBox
                  options={options}
                  handleChange={(e) => handleSelect(e)}
                  defaultValue={options?.find(
                    (option) => option.label === user.tone
                  )}
                  mainColor="#4B4DA0"
                  subColor="rgba(88, 99, 191, 1)"
                  deleteMode
                  handleDelete={onConfirmDelete}
                />
                <button className="crs-btn save-btn" type="submit">
                  저장
                </button>
              </div>
              <div className="example"></div>
            </div>
          </form>

          <div className="sample-box">
            <div className="rd-inr">
              {history?.length === 0 ? (
                <div className="empty-txt">
                  원하는 페르소나를 선택한 후 테스트 해보세요
                </div>
              ) : fetching ? (
                <div className="empty-txt">
                  선택된 페르소나로 답변을 생성중입니다. 잠시만 기다려주세요.
                </div>
              ) : (
                <Chat history={history} isFrame />
              )}
            </div>
            <div className="inp-wrp__box">
              <form
                onSubmit={handleSubmitQuestion}
                className="inp-wrp__box__form"
              >
                <textarea
                  placeholder={`자유롭게 질문해 보세요.`}
                  name="user-input"
                  type="textarea"
                  ref={inputRef}
                  onKeyDown={checkKeyType}
                  style={{
                    height: "48px",
                    minHeight: "48px",
                  }}
                />
                <button
                  type="submit"
                  id="sbm-btn"
                  style={{ display: "none" }}
                />
                <label
                  style={{
                    display: "flex",
                    alignItems: "center",
                    paddingRight: "10px",
                  }}
                  htmlFor="sbm-btn"
                >
                  <div className="img-wrp">
                    <img
                      src={Send}
                      alt="send-btn"
                      className="sb-btn crs-btn"
                      style={{
                        position: "relative",
                        transform: "none",
                        top: "0",
                        right: "0",
                      }}
                    />
                  </div>
                </label>
              </form>
            </div>
          </div>
        </div>
        <div className="setting-wrapper bottom">
          <form
            className="form-wrapper"
            onSubmit={(e) => handleSubmitForm(e, "persona")}
          >
            <div className="flx-box sep-elm">
              <p className="persona-title">
                📝 나만의 페르소나를 만들어 보세요.
              </p>
            </div>
            <div className="contents flx-box sep-elm" style={{ margin: "0" }}>
              <input
                type="textarea"
                ref={customRef}
                placeholder="경상도 사투리, 친구 같은 말투"
              />
              <button
                className={`save-btn ${!checking ? "crs-btn" : ""}`}
                type="submit"
              >
                {checking ? "확인중..." : "만들기"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Style>
  );
};
export default Persona;

const Style = styled.div`
  @media screen and (min-width: 1024px) {
    height: 100%;
  }
  @media screen and (min-width: 768.99px) and (max-width: 1023.99px) {
    height: 100%;
  }
  @media screen and (max-width: 768.98px) {
    height: calc(100%);
  }
`;
